import { render, staticRenderFns } from "./ImpactProtectorsInfo.vue?vue&type=template&id=6bac39c7"
import script from "./ImpactProtectorsInfo.vue?vue&type=script&lang=js"
export * from "./ImpactProtectorsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports